import { useEffect, useState } from "react";
import API from "../../api/api";
import Modal from "../../components/Modal";
import Toast from "../../components/Toast";

function MembershipTypes() {
    const [list, setList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [formData, setFormData] = useState({
        membershipTypeId: null,
        typeName: "",
        fee: 0
    });
    const [toast, setToast] = useState(null);

    const fetchList = () => {
        setLoading(true);
        console.log("Fetching membership types from /membership-types...");
        API.get("/membership-types")
            .then(res => {
                console.log("Membership types received:", res.data);
                setList(res.data);
            })
            .catch(err => {
                console.error("Error fetching membership types:", err);
                console.error("Error details:", err.response?.data || err.message);
                setList([]);
            })
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        fetchList();
    }, []);

    const handleOpenModal = (type = null) => {
        if (type) {
            setEditMode(true);
            setFormData({
                membershipTypeId: type.MembershipTypeId,
                typeName: type.TypeName,
                fee: type.Fee
            });
        } else {
            setEditMode(false);
            setFormData({
                membershipTypeId: null,
                typeName: "",
                fee: 0
            });
        }
        setIsModalOpen(true);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const params = new URLSearchParams({
                typeName: formData.typeName,
                fee: formData.fee
            }).toString();

            if (editMode) {
                await API.put(`/membership-types/${formData.membershipTypeId}?${params}`);
                showToast("Membership type updated successfully");
            } else {
                await API.post(`/membership-types?${params}`);
                showToast("Membership type created successfully");
            }
            setIsModalOpen(false);
            fetchList();
        } catch (err) {
            showToast("Error saving membership type", "error");
        }
    };

    const handleDelete = async (id) => {
        if (window.confirm("Are you sure?")) {
            try {
                await API.delete(`/membership-types/${id}`);
                showToast("Membership type deleted");
                fetchList();
            } catch (err) {
                showToast("Error deleting membership type", "error");
            }
        }
    };

    const showToast = (message, type = "success") => {
        setToast({ message, type });
    };

    return (
        <div className="admin-card">
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
                <h2 style={{ margin: 0 }}>Membership Types</h2>
                <button className="btn btn-primary" onClick={() => handleOpenModal()}>+ Add Type</button>
            </div>

            {loading ? (
                <p>Loading types...</p>
            ) : (
                <table className="admin-table">
                    <thead>
                        <tr>
                            <th>Type Name</th>
                            <th>Fee</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {list.map(x => (
                            <tr key={x.MembershipTypeId}>
                                <td><strong>{x.TypeName}</strong></td>
                                <td>${x.Fee}</td>
                                <td>
                                    <button className="btn btn-outline" onClick={() => handleOpenModal(x)} style={{ padding: "4px 8px", marginRight: "8px" }}>Edit</button>
                                    <button className="btn btn-outline" onClick={() => handleDelete(x.MembershipTypeId)} style={{ padding: "4px 8px", color: "var(--danger)" }}>Delete</button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}

            <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} title={editMode ? "Edit Type" : "Add Type"}>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>Type Name</label>
                        <input className="form-control" value={formData.typeName} onChange={e => setFormData({ ...formData, typeName: e.target.value })} required />
                    </div>
                    <div className="form-group">
                        <label>Fee</label>
                        <input type="number" className="form-control" value={formData.fee} onChange={e => setFormData({ ...formData, fee: e.target.value })} required />
                    </div>
                    <div style={{ marginTop: "20px", display: "flex", justifyContent: "flex-end" }}>
                        <button type="button" className="btn btn-outline" onClick={() => setIsModalOpen(false)} style={{ marginRight: "10px" }}>Cancel</button>
                        <button type="submit" className="btn btn-primary">{editMode ? "Update" : "Create"}</button>
                    </div>
                </form>
            </Modal>

            {toast && <Toast message={toast.message} type={toast.type} onClose={() => setToast(null)} />}
        </div>
    );
}

export default MembershipTypes;